module.exports = __webpack_public_path__ + "static/media/food-detail-02.7b41c5a2.jpg";